import * as React from 'react'
import ServiceWorkingHoursItem from '../../../../containers/services/ServiceWorkingHoursItem'
import { IStoreState, IWorkingHoursItem } from '../../../../types/index'
import Toggle from '../../../ui/Toggle'

interface IServiceWorkingHoursProps {
  serviceId?: string
  orgId: string
  workingHoursList: { [key: string]: IWorkingHoursItem }
  isAllDaysActive: boolean
  onAddClick: () => void
  onAllDaysActiveChange: (id: string, allDaysActive: boolean) => void
}

class ServiceWorkingHours extends React.Component<IServiceWorkingHoursProps, IStoreState> {
  constructor(props: IServiceWorkingHoursProps) {
    super(props)
  }

  public render() {
    const { workingHoursList, serviceId, orgId, isAllDaysActive } = this.props

    return (
      <div>
        <div className='flex flex-row items-center mt3'>
          <span className='h5 font-dark-grey col-4'>Availability 24/7</span>
          <Toggle state={isAllDaysActive} onClick={this.handleAllDaysActiveClick(isAllDaysActive)} />
        </div>
        {!isAllDaysActive && (
          <React.Fragment>
            {Object.values(workingHoursList).map(it => (
              <ServiceWorkingHoursItem
                key={`working-hours-${it.id}`}
                className='ServiceWorkingHoursItemComponent'
                workingHoursItem={it}
              />
            ))}
            <div
              className='add-wh-button cursor--pointer mt2 col-1 h5 font-blue-grey'
              onClick={this.handleAddClick(orgId, serviceId)}
            >
              + Add
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }

  private handleAllDaysActiveClick = (currentVal: boolean) => () => {
    if (this.props.serviceId) {
      this.props.onAllDaysActiveChange(this.props.serviceId, currentVal)
    }
  }

  private handleAddClick = (orgId: string, serviceId?: string) => () => {
    this.props.onAddClick()
  }
}

export default ServiceWorkingHours



// WEBPACK FOOTER //
// ./src/components/services/edit/working-hours/ServiceWorkingHours.tsx